import React, {Component} from 'react';
import {Input, Button} from 'reactstrap';
import { connect } from 'react-redux';
import { getAuthToken } from '../../store/utility';
import axios from 'axios';


import * as actions from '../../store/actions/index';
import Spinner from 'react-bootstrap/Spinner';

class PasswortAendern extends Component {
    state = {
        oldPassword: '',
        newPassword: '',
    }

    constructor(props) {
        super(props);
        const token = getAuthToken();
        axios.get(this.props.apiUri + 'Kita', { headers: { 'Authorization': `Bearer ${token}` } })
            .then(response => {
                this.setState({ kitas: response.data });
            }).then(
                axios.get(this.props.apiUri + 'Authentication/GetAdmins', { headers: { 'Authorization': `Bearer ${token}` } })
                    .then(response => {
                        this.setState({ admins: response.data });
                    }).then(
                        axios.get(this.props.apiUri + 'Kita/GetKitasWithKitaBenutzer', { headers: { 'Authorization': `Bearer ${token}` } })
                            .then(response => {
                                this.setState({ kitaBenutzer: response.data });
                            }).then(
                                axios.get(this.props.apiUri + 'Kita', { headers: { 'Authorization': `Bearer ${token}` } })
                                    .then(response => {
                                        this.setState({ kitas: response.data });
                                    }))));
    }

    usernameChangedHandler = event => {
        this.setState({
            username: event.target.value
        });
    }

    passwordChangedHandler = event => {
        this.setState({
            password: event.target.value
        })
    }

    registerUser = () => {
        this.props.onAuth(this.props.preUrl, this.state.username, this.state.password, true);
    }

    loginUser = () => {
        this.props.onAuth(this.props.preUrl, this.state.username, this.state.password, false);
    }

    render(){
        const style = {
            display: 'block ruby',
            padding: '10px'
        };
        let userInput = (
            <div>
                <div style={style}>
                    <h5 style={style}>Benutzername:</h5>
                    <Input className="w-50" type="text" id="UsernameInput" value={this.state.username} onChange={(e) => this.usernameChangedHandler(e)}/>
                </div>
                <div style={style}>
                    <h5 style={style}>Passwort:</h5>
                    <Input className="w-50" type="password" id="PasswordInput" value={this.state.password} onChange={(e) => this.passwordChangedHandler(e)}/>
                </div>
            </div>
        );

        if(this.props.loading){
            userInput = <Spinner animation="border" />
        }

        let errorMessage = null;

        if(this.props.error){
            errorMessage = (
                <p>{this.props.error.message}</p>
            );
        }


        return (
            <div>
                <h3>Passwort �ndern</h3>
                <br />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.loading,
        error: state.error,
        isAuthenticated: state.token !== null,
        preUrl: state.apiUri
    };
  };

const mapDispatchToProps = dispatch => {
    return {
        onAuth: (preUrl, email, password, isRegister) => dispatch(actions.auth(preUrl, email, password, isRegister))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswortAendern);